import HttpRequest from './HttpRequest'

class KnowledgeTypeProvider extends HttpRequest {
  findAll () {
    return this.get('/knowledge-type/all')
  }

  findOne (id) {
    return this.get(`/knowledge-type/${id}`)
  }

  create (payload) {
    return this.post('/knowledge-type', payload)
  }

  update (id, payload) {
    return this.patch(`/knowledge-type/${id}`, payload)
  }

  softDelete (id) {
    return this.delete(`/knowledge-type/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/knowledge-type?page=${page}&limit=${limit}`, query)
  }
}

export default KnowledgeTypeProvider
